import { SpatialOption, spatialValuesInRem } from './spatialValues';

export type SpatialSquishInsetOption = SpatialOption.sm | SpatialOption.md | SpatialOption.lg;
export type SpatialSquishInset = { [option in SpatialSquishInsetOption | SpatialOption.default]: string };

/**
 * Unlike it's square counterpart, a squished inset reduces space at the **top** and **bottom** by 50%.
 *
 * **Usage**: applied to buttons and cell-like containers like a data table or list item.
 * `padding: spatialSquishInset.default`
 */
export const spatialSquishInset: SpatialSquishInset = {
  default: `${spatialValuesInRem.sm} ${spatialValuesInRem.md}`,
  sm: `${spatialValuesInRem.xs} ${spatialValuesInRem.sm}`,
  md: `${spatialValuesInRem.sm} ${spatialValuesInRem.md}`,
  lg: `${spatialValuesInRem.md} ${spatialValuesInRem.lg}`
};
